<template>
  <div class="bk">
    <Topnav />
    
    <div class="mytip" v-show="showtip">正在分析中，请稍候</div>
    <div class="upload-page">
      <div class="upload-area">
        <div class="upload-label">请上传你的题目</div>

        <div class="row3">
          <div class="mypic">
            <van-uploader
              max-count="1"
              preview-size="95"
              @click-preview="clickpreview"
              :preview-image="true"
              :preview-full-image="false"
              :after-read="afterRead"
              :before-read="beforeRead"
              v-model="fileList"
              class="myup"
            />
          </div>
        </div>

        <!--<div v-if="fileList.length > 0" class="delete-btn" @click.stop="deleteFile">
          <van-icon name="delete" size="20" />
          删除
        </div>-->

        <div class="upload-tips">最大5MB/个，支持png、jpg格式</div>

        <van-button
          type="primary"
          size="large"
          round
          class="analyze-btn"
          @click="handleAnalyze"
        >
          开始分析
        </van-button>
      </div>
    </div>


    <!-- 图片展示网格 -->
    <div class="image-grid" v-if="!cutting && imageDataList.length">
      <div v-for="(item, idx) in imageDataList" :key="idx" class="image-item">
        <div class="img-wrapper">
          <img :src="item.dataURL" :alt="'第' + (idx + 1) + '题'" />
        </div>
        <div class="img-label">
          <span>#{{ idx + 1 }}</span>
          <span class="size">{{ item.width }}×{{ item.height }}</span>
        </div>
      </div>
    </div>

    <!--显示图片编辑-->
    <div class="uploadava">
      <!-- <van-popup
        duration="0"
        v-model:show="showCropper"
        position="top"
        :style="{ height: '100%' }"
      >-->
      <van-dialog
        v-model:show="loadingShow"
        :show-cancel-button="false"
        :showConfirmButton="false"
      >
        <van-loading size="50">上传中... </van-loading>
      </van-dialog>
      <div class="cropper-container" v-show="showCropper">
        <!--<van-loading
          v-show="loadingShow"
          size="50"
          >上传中...
        </van-loading>-->
        <van-nav-bar
          left-text="取消"
          right-text="选择"
          @click-left="onClickLeft"
          @click-right="getCropBlob"
        />
        <vueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :info="option.info"
          :full="option.full"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :fixedNumber="option.fixedNumber"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :fixedBox="option.fixedBox"
          :high="option.high"
          :mode="option.mode"
        />

      </div>
      <!--</van-popup>  原来fixed-->
    </div>
    

    <Footer v-show="showCropper==false" />
  </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted, reactive } from "vue";
import Footer from "@/components/Footer.vue";
import Topnav from "@/components/Topnav.vue";
import { showImagePreview } from "vant/es/image-preview";
import "vant/es/image-preview/style";
import { showFailToast, showSuccessToast} from "vant/es/toast";
import "vant/es/toast/style";
//import { Toast } from "vant/es/toast";


import axios from "axios";
//import "vue-cropper/dist/index.css";
//import { VueCropper } from "vue-cropper";
import { VueCropper } from 'vue-cropper'
import 'vue-cropper/dist/index.css'
//import VConsole from 'vconsole';

// 判断是否为开发环境（或者通过 URL 参数控制，如 ?debug=1）
//if (import.meta.env.DEV) {
//  new VConsole();
//}

document.title = "全科学习助手";
export default {
  name: "Index",
  components: { Footer, Topnav, VueCropper },
  setup() {
    const { proxy } = getCurrentInstance();
    const fileList = ref([]);
    let qiniuData = {
      key: "",
      token: "",
    };

    let showtip=ref(false);//是否显示提示框

    let showCropper = ref(false); // 裁剪的弹窗
    let loadingShow = ref(false);
    let option = reactive({
      img: "",
      outputSize: 0.8,
      info: false, // 裁剪框的大小信息
      outputType: "jpeg", // 裁剪生成图片的格式
      canScale: true, // 图片是否允许滚轮缩放
      autoCrop: true, // 是否默认生成截图框
      autoCropWidth: 0, //300 + "px", // 默认生成截图框宽度window.innerWidth -
      autoCropHeight: 0, // 300 + "px", // 默认生成截图框高度window.innerWidth -
      high: true, // 是否按照设备的dpr 输出等比例图片
      fixedBox: false, // 固定截图框大小 不允许改变
      fixed: false, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例
      full: true, // 是否输出原图比例的截图
      canMoveBox: true, // 截图框能否拖动
      original: false, // 上传图片按照原始比例渲染
      centerBox: true, // 截图框是否被限制在图片里面
      infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      mode: "contain",//"100% auto", // 图片默认渲染方式 "contain", //
      canMove: false,
    });
    let cureditpicid = -1;

    const uploadFile = ref(null);
    const imageDataList = ref([]);
    const cutting = ref(false);
//http://jiasu2.dayin163.com/0005d5ae-b7bc-443b-b41b-0547fd3385b51.jpg
    const upload_qiniu_url = "https://upload.qiniup.com"//"https://upload-z2.qiniup.com";
    const upload_qiniu_addr = "http://jiasu2.dayin163.com/";//"http://gzqy.dayin163.com/";
    // let cureditpicid = -1;
    const uploaderRef = ref(null);
    const cutimg = ref([]);

    const getQiniuToken = () => {
      proxy.$http
        .post("https://www.dayin163.com/pncy/GetQiniuToken.php")
        .then((res) => {
          console.log(res);
          qiniuData.token = res.data.uptoken;
        });
    };
    const beforeRead = (file) => {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 6;
      if (!isJPG && !isPNG) {
        showFailToast("图片只能是 JPG/PNG 格式!");
        //this.$message.error('图片只能是 JPG/PNG 格式!')
        return false;
      }
      if (!isLt2M) {
        showFailToast("图片大小不能超过 6MB!");
        //this.$message.error('图片大小不能超过 2MB!')
        return false;
      }
      qiniuData.key = "xq_" + Date.now().toString() + file.name;
      showCropper.value = true;
      imageToBase64(file);
      //imageFileName = file.name

      return false;
    };
    /*const imageToBase64 = (file) => {
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => {
        console.log("来渲染了");
        option.img = reader.result;
        console.log(reader);
      };
    };*/
    const imageToBase64 = (file) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        option.img = reader.result;
       const img = new Image();
        img.onload = () => {
          option.autoCropWidth = img.width -20+ "px";
          option.autoCropHeight = img.height-20 + "px";
        };
        img.src = reader.result;
      };
    };
    const onClickLeft = () => {
      //this.loadingShow = false
      loadingShow.value = false;
      showCropper.value = false;
      //this.$parent.showPhotoUploader = false
    };
    const clickpreview = (file, res) => {
      cureditpicid = res.index; //当前的id
      console.log("当前id" + cureditpicid);
      fetch(file.url)
        .then((response) => response.blob())
        .then((res) => {
          //打印res出来的就是blob类型
          var url = file.url;
          var urlArr = url.split("?");
          var k = urlArr[0],
            appU = k.split("/");
          var myfn = appU[appU.length - 1];

          console.log(res);
          qiniuData.key = "xq_" + Date.now().toString() + myfn;
          showCropper.value = true;
          imageToBase64(res);
        });
    };
    const afterRead = (files) => {
      //console.log('准备上传')
      showSuccessToast("开始上传");
      let imgList = []; //定义存储file的数组
      //判断files的类型
      if (files instanceof Array) {
        for (let i = 0; i < files.length; i++) {
          imgList = [...imgList, files[i].file];
        }
      } else {
        imgList = [...imgList, files.file];
      }
      //遍历数组
      let data = new FormData();
      data.append("token", qiniuData.token);
      data.append("key", qiniuData.key);
      let icount = imgList.length;
      let istep = 0;
      for (let i = 0; i < icount; i++) {
        /* data.set("file", imgList[i]);
        proxy.$http.post(upload_qiniu_url, data).then((res) => {
          console.log(upload_qiniu_addr + res.data.key);
          istep = istep + 1;
          if (istep == icount) {
            //console.log("上传成功！");
            Toast("上传成功！");
            //上传完成。
          }
        });*/
        istep = istep + 1;
        //Toast(upload_qiniu_url + upload_qiniu_addr);
      }
    };
    const getCropBlob = () => {
      //showFailToast("步骤1");
      // let formData = new FormData()
      //this.loadingShow = true;
      //console.log(this.option);
      //console.log("步骤1")
      loadingShow.value = true;
      proxy.$refs.cropper.getCropBlob((mydata) => {
        /*FileList.append({
          url:data
        })*/
        //const file = data.blob;
        // formData.append('headFile', data, this.imageFileName)
        // formData.append('id', this.$store.getters.user.userId)
        //遍历数组
        //   const myBlob = new window.Blob([mydata], {type: 'image/jpeg'});
        // const myurl  = window.URL.createObjectURL(myBlob);
        uploadFile.value = mydata;
        let data = new FormData();
        data.append("token", qiniuData.token);
        data.append("key", qiniuData.key);
        data.append("file", mydata);

        //showFailToast("步骤2");
        //showFailToast(qiniuData.token);
        //showFailToast(qiniuData.key);
        proxy.$http.post(upload_qiniu_url, data).then((res) => {
          console.log(upload_qiniu_addr + res.data.key);
          if (cureditpicid == -1) {
            //新增
            console.log("新增的");
            //showFailToast(upload_qiniu_addr + res.data.key);
            fileList.value.push({
              url: upload_qiniu_addr + res.data.key,
              isImage: true,
            });
            loadingShow.value = false;
            showCropper.value = false;
          } //修改
          else {
            console.log(cureditpicid);
            //Vue.set(this.classes,1,{id:123,name:'计应171班'})
            //this.$set(this.classes,1,{id:123,name:'计应171班'});
            fileList.value.splice(cureditpicid, 1, {
              url: upload_qiniu_addr + res.data.key,
              isImage: true,
            });
            /*fileList.value[cureditpicid]={
              url: upload_qiniu_addr + res.data.key,
              isImage: true
            }*/

            cureditpicid = -1; //恢复为新增

            loadingShow.value = false;
            showCropper.value = false;
          }

          //istep = istep + 1;
          //if (istep == icount) {
          //console.log("上传成功！");
          //Toast("上传成功！");
          //showCropper.value = false;
          //上传完成。
          //}
        });

        // uploadAva(formData).then((res) => {
        // this.showCropper = false
        //proxy.$emit('update:showAta', false)
        // this.$emit('update:avaUrl', res.data)
        // })
      });
    };

    // 删除图片
    const deleteFile = () => {
      fileList.value = [];
      //showSuccessToast("已删除");
    };

    // 预览大图
    const previewImage = () => {
      if (fileList.value.length === 0) return;
      showImagePreview({
        images: [fileList.value[0].url],
        startPosition: 0,
      });
    };

    // 触发文件选择
    const triggerUpload = () => {
      if (uploaderRef.value) {
        uploaderRef.value.chooseFile();
      }
    };
    const myoption = {
      inputs: { blType: "100" },
      query: "1",
      response_mode: "blocking",
      conversation_id: "",
      user: "abc-123",
      files: [],
    };
    const mylog = ref("");
    // 开始分析
    const handleAnalyze = async () => {
      if(showtip.value) {
        showSuccessToast("正在分析中...");
        return;
      }
      showtip.value=true;
      if (fileList.value.length === 0) {
        // showFailToast("请先上传题目图片");
        return;
      }
      /*myoption.files[0].url=fileList.value[0].url;
      myoption.files[0].transfer_method="remote_url";
      myoption.files[0].type="image";*/

      myoption.files[0] = {
        url: fileList.value[0].url,
        transfer_method: "remote_url",
        type: "image",
      };
      console.log(myoption);
      showSuccessToast("开始分析...");
      //Toast("开始分析...");
      //发给智能体
      try {
        const response = await axios.post("https://agent.gjt-smart.com/v1/chat-messages", myoption, {
          headers: { Authorization: "Bearer app-hbVnpcx6R0YocpD6eO8SCOzv" },
        });
        mylog.value = JSON.parse(response.data.answer);
        console.log(mylog);
        cutImage(); //切割图片
      } catch (error) {
        console.error(error);
      }
    };

    //切割图片
    function loadImageFromFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = () => reject(new Error("图片解码失败"));
          img.src = e.target.result;
        };
        reader.onerror = () => reject(new Error("文件读取失败"));
        reader.readAsDataURL(file);
      });
    }

    // 工具函数：dataURL → Blob
    function dataURLToBlob(dataURL) {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }

    function cutQuestionsFromImage(img, questions) {
      const fullCanvas = document.createElement("canvas");
      fullCanvas.width = img.width;
      fullCanvas.height = img.height;
      const ctx = fullCanvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const result = [];
      for (let i = 0; i < questions.length; i++) {
        const points = questions[i].location.points;
        let minX = Infinity,
          minY = Infinity,
          maxX = -Infinity,
          maxY = -Infinity;
        for (const p of points) {
          if (p.x < minX) minX = p.x;
          if (p.x > maxX) maxX = p.x;
          if (p.y < minY) minY = p.y;
          if (p.y > maxY) maxY = p.y;
        }
        const sx = Math.max(0, Math.floor(minX));
        const sy = Math.max(0, Math.floor(minY));
        const sw = Math.min(img.width - sx, Math.ceil(maxX - minX));
        const sh = Math.min(img.height - sy, Math.ceil(maxY - minY));
        if (sw <= 0 || sh <= 0) continue;

        const cropCanvas = document.createElement("canvas");
        cropCanvas.width = sw;
        cropCanvas.height = sh;
        const cropCtx = cropCanvas.getContext("2d");
        cropCtx.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
        const dataURL = cropCanvas.toDataURL("image/png");
        result.push({ dataURL, width: sw, height: sh });
      }
      return result;
    }

    async function cutImage() {
      if (!uploadFile.value) {
        alert("请先上传图片");
        return;
      }
      if (cutting.value) return;

      cutting.value = true;
      imageDataList.value = [];
      // 上传
      try {
        const img = await loadImageFromFile(uploadFile.value);
        const result = cutQuestionsFromImage(img, mylog.value.questions);
        imageDataList.value = result;
        console.log(
          "切割完成，图片数组：",
          result.map((r) => r.dataURL)
        );

        cutimg.value = [];
        const uploadPromises = imageDataList.value.map((item, index) => {
          // 1. 将 dataURL 转为 Blob
          const blob = dataURLToBlob(item.dataURL);
          // 2. 生成唯一文件名
          const ext = item.dataURL.split(";")[0].split("/")[1] || "png";
          const fileName = `question_${Date.now()}_${index}_${Math.random()
            .toString(36)
            .slice(2, 6)}.${ext}`;

          // 3. 构造 FormData
          const data = new FormData();
          data.append("token", qiniuData.token);
          data.append("key", fileName); // 使用动态 key
          data.append("file", blob, fileName); // 第三个参数指定文件名

          // 4. 返回上传 Promise
          return proxy.$http
            .post(upload_qiniu_url, data, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
              const url = upload_qiniu_addr + res.data.key;
              cutimg.value.push(url);
              console.log(`切片 ${index} 上传成功：`, url);
              return url;
            })
            .catch((err) => {
              console.error(`切片 ${index} 上传失败：`, err);
              // 可决定是否继续或抛出错误
              throw err;
            });
        });

        // 等待所有上传完成
        await Promise.all(uploadPromises);
        console.log("所有切图上传成功！", cutimg.value);

        // 进入下一页，传递数据
        proxy.$router.push({
          path: "/showtm",
          query: { data: JSON.stringify(cutimg.value) },
        });
      } catch (err) {
        alert("切割或上传失败：" + err.message);
        console.error(err);
      } finally {
        cutting.value = false;
      }

      /*
      try {
        const img = await loadImageFromFile(uploadFile.value);
        const result = cutQuestionsFromImage(img, mylog.value.questions); //利用返回的json
        imageDataList.value = result;
        console.log(
          "切割完成，图片数组：",
          result.map((r) => r.dataURL)
        );

        //上传七牛云空间
        // 提取文件对象（单文件情况）
        cutimg.value = [];
        console.log('数组是：',imageDataList.value)
        for (var i = 0; i < imageDataList.value.length; i++) {
          // 提取文件对象（单文件情况）
          const file = imageDataList.value[i].dataURL;
          //uploadFile.value=file;
          // 构造 FormData 上传
          const data = new FormData();
          data.append("token", qiniuData.token);
          data.append("key", qiniuData.key);
          data.set("file", file);

          proxy.$http.post(upload_qiniu_url, data).then((res) => {
            // 上传成功后，将七牛云地址放入列表
 
            console.log(upload_qiniu_addr + res.data.key);
            cutimg.value.push(upload_qiniu_addr + res.data.key);
            //showSuccessToast('上传成功');
          });
        }
        console.log('上传切图到七牛云成功！',cutimg.value)
        //进入下一个页面（把cutimg发回给智能体)
        // proxy.$router.push({ path: "/showtm" });
         proxy.$router.push({
          path: "/showtm",
          query: { 
            data: JSON.stringify(cutimg.value) 
          }
        });

      } catch (err) {
        alert("切割失败：" + err.message);
        console.error(err);
      } finally {
        cutting.value = false;
      }*/
    }

    function clearResults() {
      imageDataList.value = [];
      uploadFile.value = null;
      //if (fileInput.value) fileInput.value = '';
    }

    //切割图片

    onMounted(() => {
      //localStorage.getItem("pnxqtel") == null ||
      //localStorage.getItem("pnxqtel") == ""
      getQiniuToken(); //获取七牛云
    });

    return {
      onClickLeft,
      getCropBlob,
      clickpreview,
      showCropper,
      option,
      cutimg,
      uploadFile,
      imageDataList,
      cutting,
      //handleFileUpload,
      cutImage,
      clearResults,
      mylog,
      fileList,
      uploaderRef,
      beforeRead,
      afterRead,
      deleteFile,
      previewImage,
      triggerUpload,
      handleAnalyze,
      showtip
    };
  },
};
</script>

<style scoped>
.upload-page {
  min-height: 100vh;
  background: #f5f6fa;
  padding: 20px 24px;
}
.upload-area {
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px 24px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.upload-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}
.upload-btn {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border: 2px dashed #d0d5e0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0b8c8;
  cursor: pointer;
  transition: all 0.3s;
  overflow: hidden;
}
.upload-btn:hover {
  border-color: #1989fa;
  color: #1989fa;
}
.upload-btn:active {
  transform: scale(0.95);
}
.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.delete-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #ee0a24;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 16px;
  padding: 4px 12px;
  border-radius: 12px;
  background: #fff5f5;
}
.delete-btn:active {
  transform: scale(0.95);
}
.upload-tips {
  font-size: 13px;
  color: #b0b8c8;
  margin-bottom: 28px;
}
.analyze-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  background: linear-gradient(135deg, #1989fa, #3d7bf7);
  border: none;
}
/* 修复 van-uploader 容器居中 */
:deep(.van-uploader) {
  display: flex;
  justify-content: center;
}
:deep(.van-uploader__upload) {
  background: transparent;
  border: none;
  padding: 0;
  width: auto;
  height: auto;
}
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 16px;
}
.image-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  transition: 0.15s;
}
.image-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}
.image-item .img-wrapper {
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.image-item .img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: white;
}
.image-item .img-label {
  padding: 8px 12px;
  font-weight: 600;
  font-size: 14px;
  color: #1e3a5f;
  background: white;
  border-top: 1px solid #e9edf4;
  display: flex;
  justify-content: space-between;
}
.image-item .img-label .size {
  font-weight: 400;
  color: #6b7f98;
  font-size: 13px;
}

.row2 {
  font-size: 13px;
  text-align: center;
}
.row3 {
  font-size: 15px;
  margin-bottom: 20px;
  margin: 0px 10px 0px 10px;
  padding: 10px;
  background-color: white;
  border-radius: 8px;
}
.myrow {
  border-top: 1px solid #e4dede;
  padding: 7px 10px 7px 10px;
}
.mytitle {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
}
.mypic {
  padding: 10px;

}
.cropper-container {
  top: 0;
  left: 0;
  height: 100%;
  position: fixed;
  width: 100%;

  display: flex;           /* 新增 */
  flex-direction: column;  /* 新增 */
}
/* 导航栏固定高度，不伸缩 */
.cropper-container .van-nav-bar {
  flex-shrink: 0;
}

/* 裁剪器自动填满剩余高度 */
.cropper-container .vue-cropper {
  flex: 1;
  width: 100%;
}

.showtxt {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: red;
}
.mytip{
  text-align:center;
  color: red;
  font-size: 16px;

  height: 30px;
  line-height: 30px;
}
/* 上传虚线框 */
.myup :deep(.van-uploader__upload) {
  border: 2px dashed #e5e5e5;
  border-radius: 8px;
  background: #fafafa;
  min-height: 100px;
}


</style>